<template>
  <div>
    <div class="page-error-info" v-if="pageError">
      <p>您的简历状态已更新，如需反馈补贴信息，请直接告知HR。</p>
    </div>
    <div v-else class="subsidy-wrapper">
      <van-form ref="subsidyCollectForm" :show-error="false" @submit="submit">
        <p class="title">个人信息</p>
        <van-field
          :value="name"
          label="姓名"
          placeholder="姓名"
          class="train-confirm-field disabled"
          :disabled="true"
        />
        <van-field
          :value="phone"
          type="tel"
          name="联系电话"
          label="联系电话"
          class="train-confirm-field disabled"
          placeholder="联系电话"
          :disabled="true"
        />
        <van-field
          :value="dateDuring"
          name="参培日期"
          label="参培日期"
          class="train-confirm-field disabled"
          placeholder="参培日期"
          :disabled="true"
        />
        <p class="title">其它信息</p>
        <van-field
          readonly
          clickable
          :rules="[
            {
              validator: idCardNoRegValidator,
              trigger: 'onChange',
              message: '位数报错',
            },
          ]"
          @click="idKeyboard = true"
          :value="formData.idCardNo"
          type="number"
          name="身份证号"
          label="身份证号"
          class="train-confirm-field id-card-no"
          placeholder="请输入本人身份证号"
        />
        <van-number-keyboard
          v-model="formData.idCardNo"
          :show="idKeyboard"
          :maxlength="18"
          extra-key="X"
          close-button-text="完成"
          @blur="idKeyboard = false"
        />

        <van-field
          v-model="formData.bankName"
          :rules="[
            {
              required: true,
              trigger: 'onChange',
              message: '必填项',
            },
          ]"
          @input="bankNameChange"
          name="开户银行"
          label="开户银行"
          type="textarea"
          :maxlength="20"
          autosize
          class="train-confirm-field bank-name"
          placeholder="优先招商银行，若是信用社、合作联社、农商行等，要精确到银行名称"
        />

        <van-field
          readonly
          clickable
          class="train-confirm-field bank-province"
          name="开户行所在地"
          :rules="[
            {
              required: true,
              trigger: 'onChange',
              message: '必填项',
            },
          ]"
          :value="formData.bankProvince"
          label="开户行所在地"
          placeholder="请输入开户主行所在省份"
          @click="vanAreaShow = true"
        >
          <template #button>
            <van-icon name="arrow" />
          </template>
        </van-field>

        <van-popup
          v-model="vanAreaShow"
          :close-on-popstate="true"
          :overlay="true"
          position="bottom"
        >
          <van-area
            title="城市"
            :value="initCity"
            :columns-num="2"
            :area-list="areaList"
            @cancel="vanAreaShow = false"
            @confirm="areaConfirm"
          />
        </van-popup>

        <van-field
          readonly
          clickable
          @click="show = true"
          :rules="[
            {
              validator: bankCardNoRegValidator,
              trigger: 'onChange',
              message: '位数报错',
            },
          ]"
          :value="bankCardNo"
          name="银行卡号"
          label="银行卡号"
          class="train-confirm-field bank-card-no"
          placeholder="银行卡号"
        />

        <van-number-keyboard
          close-button-text="完成"
          v-model="formData.bankCardNo"
          :show="show"
          extra-key="00"
          :maxlength="19"
          @blur="show = false"
          @input="format"
          @delete="format"
        />

        <div class="agree">
          <div class="select-c" @click="agreeCheck = !agreeCheck">
            <div v-if="agreeCheck" class="select-o"></div>
          </div>
          <div class="text-w">
            <span class="text-l" @click="agreeCheck = !agreeCheck"
              >我已同意</span
            >
            <span class="text-r" @click="statementPop = true"
              >个人信息隐私保护申明</span
            >
          </div>
        </div>

        <div style="padding: 20px 12px;">
          <van-button
            round
            block
            type="info"
            :disabled="!agreeCheck"
            native-type="submit"
          >
            确认
          </van-button>
        </div>
      </van-form>
      <van-popup
        class="statement-pop"
        v-model="statementPop"
        :close-on-popstate="true"
        :overlay="true"
      >
        <div class="statement-pop-w">
          <div class="pop-content">
            <p class="tit">
              本政策概述：
            </p>
            <p class="item">
              我们即北京猿力教育科技有限公司及其关联公司（以下简称“本公司”），如何通过我们网页上的线上招聘系统及其他方式收集求职者的资料，以及我们如何处理（该词定义见下文）及可能会如何使用该等资料。
            </p>
            <p class="item">定义：</p>
            <p class="item">
              求职者：指任何透过该网页申请（直接或经一名代表间接）加入本公司的个人。
            </p>
            <p class="item">
              处理：包括收集、储存、检索、变更、披露或销毁个人资料。
            </p>
            <p class="item">
              个人资料：有关确认或识别个人的任何形式的信息，可能包括（但不限于）个人身份识别信息（如姓名、地址、照片、电子邮件地址、银行卡号、受聘详细资料、薪酬信息等）。
            </p>
            <p class="item">
              本政策载列了我们处理您向我们提供的任何个人资料（包括您通过我们的招聘网站（互联网址：[
              https://garden.yuanfudao.com/#/subsidy/collect
              ]（下文简称“招聘网站”）提供的信息））以及我们接收自您或第三方（如推荐人）的与您的工作申请有关的资料所遵照的依据。请仔细阅读以下内容，以了解我们有关您的资料的意见和惯例，以及我们将如何处理这些资料。您通过招聘网站或其他第三方途径向我们提供个人资料，即表示您承认及认可本政策。
            </p>
            <p class="item">
              本政策仅针对我们控制的个人资料：您可能会通过第三方提交您的信息，他们会根据自身的独立隐私政策处理您的个人资料。我们对该等第三方如何处理您的个人资料概不负责。
            </p>
            <p class="item">
              本政策可不时修订，而如果求职者获聘加入本公司，本政策不构成求职者的雇佣合约的一部分。
            </p>
            <p class="tit">1. 本公司处理个人资料的原因</p>
            <p class="item">
              本公司评核求职者的求职申请时，有必要处理求职者的个人资料，同时，处理及考虑求职者加入本公司的申请牵涉我们的合法业务权益，故处理求职者的个人资料是有需要的。
            </p>
            <p class="item">
              本公司亦会在以下情况处理个人资料（包括下文述及的特殊类别个人资料）：本公司为履行任何法例义务而有需要时；法律诉讼程序、执法行动或政府调查有所要求时；或与求职者的职务相关的情况下。
            </p>
            <p class="tit">2. 本公司收集的个人资料</p>
            <p class="item">
              本公司经由该网页及透过其他方式收集的个人资料包括但不限于以下类别：
              联系信息──（包括姓名、地址、邮箱、电话号码、微信）
              个人资料──（包括性别及出生日期、身份证号、婚姻状况）
              受雇及学历信息──（包括过往受雇纪录及曾担任的职位、资历、就读院校及曾获得的专业认证信息）。
            </p>
            <p class="item">
              本公司亦可能从求职者上载至该网页的任何求职信或工作样本中，收集其他类别个人资料。同时我们会就您的申请从第三方接收信息，如推荐人、招聘人员及提供背景检查的组织（在适用法律允许的情况下，这将/可能包括工作权利、犯罪记录背景调查、机动车记录背景调查及工作经验背景调查）。
            </p>
            <p class="item">
              我们收集的关于您对招聘网站使用的信息。当您使用我们的招聘网站时，我们会自动向您收集若干数据，包括IP地址或其他设备唯一标识符、cookie收集的有关您对门户网站使用的信息、移动运营商（若适用）、时区设置、操作系统及平台以及有关您对门户网站使用的信息（如完成职位申请的时间、页面浏览历史、申请记录等）（下文简称“使用信息”）。
            </p>
            <p class="tit">3.我们如何使用您的信息：</p>
            <p class="item">
              您理解并同意，您的信息将被本公司用于以下用途：识别及评估您是否适合相关职位；确保遵循我们的内部政策；确定及验证您的就业资格；开展背景调查（包括在适用法律允许的情况下，核实资料、资格及进行犯罪记录调查）；与您通信；
              管理、开发及改进门户网站；及向您发送与您的状况匹配的新职位通知。
            </p>
            <p class="tit">4. Cookie</p>
            <p class="item">
              我们采用cookie提升您在使用招聘网站时的体验。Cookie是安装在您设备上的一些小文件，我们可以通过其提供特定特性和功能。招聘网站会为内部流量监控、容量目的或招聘网站管理目的检测和使用您的IP地址或域名。
              我们仅使用绝对必需的cookie（即运营招聘网站必需的cookie），例如，包括使您能够登录招聘网站安全区域的cookie。
            </p>
            <p class="tit">5. 本公司如何保障个人资料</p>
            <p class="item">
              本公司将采取一切合理必要的步骤，确保实施恰当的保安措施，以保障个人资料。在厘定恰当的保安措施时，本公司会考虑科技发展情况，并且评估现有措施是否足以防范安全漏洞可能带来的损害风险。本公司已实施适当的保安措施，足以防范「处理」过程出现的风险，并且可预防任何人未经授权披露或非法披露资料，以及防止个人资料遭受意外损失、销毁或损毁。
            </p>
            <p class="item">
              您理解并同意，尽管本公司已采取了一系列适当安保措施，但是通过互联网传输信息并非绝对安全。虽然我们将竭尽所能保护您的个人资料，但我们无法保证通过招聘网站传输的您的信息的安全，任何该等传输应由您自担风险。当我们收到您的信息后，我们会采取适当的技术和组织措施保护您的个人资料免遭丢失、盗窃及未获授权的使用、访问或修改。
            </p>
            <p class="tit">6. 本公司与谁人共用个人资料</p>
            <p class="item">
              本公司可能会在有需要时，为招聘求职者一事涉及的合法业务目的，或为遵守适用法律规定，与本公司内部共用透过该网页及其他方式获取的个人资料。
            </p>
            <p class="item">
              本公司也可能向第三方披露个人资料，以便该等第三方代表本公司履行服务，或供法律／监管目的之用。在将个人资料披露予第三方时，本公司将实施合适保障措施以确保资料以合法方式处理并受到适当保护。（例如：为我们提供招聘支持的IT服务供应商；核实您作为申请一部分提供的信息的背景调查服务供应商；
              推荐人；及我们使用的人才招聘机构）
            </p>
            <p class="tit">7. 您的权利</p>
            <p class="item">
              如果您希望就经由招聘网站或其他方式所取得个人资料的处理，行使适用法律所赋予您的权利，您必须经书面作出要求，并向您当地的人力资源联络人提出有关要求。为确认您的身份及出于保安目的，本公司可向您索取额外资料，然后才会向您披露所需资料。
            </p>
            <p class="tit">8. 保留您的个人资料</p>
            <p class="item">
              我们会在求职者申请加入本公司的期间保留个人资料。如求职者没有加入本公司，我们会保留其个人资料，时间长短视乎本公司上述的合法业务权益需要而定，并且会依循适用法律及我们的保留政策及程序，在该期间过后，该等资料会被删除或设定为无法使用。
            </p>
            <p class="tit">9.其他</p>
            <p class="item">
              未来本政策若有任何变更，我们会在本网页发布。请经常进行核查，以查看本政策的任何更新或变动。
              欢迎提出有关本政策的问题、评论或要求，任何问题、评论或要求请发送至以下电子邮件地址：zhangjj@fenbi.com
              zhanghe02@fenbi.com
            </p>
            <p class="tit" style="text-align:center">
              北京猿力教育科技有限公司
            </p>
            <p class="tit" style="text-align:center">
              2020年7月3日
            </p>
          </div>
          <div class="pop-title-w">
            <span class="pop-title">申请岗位须知</span>
            <div class="pop-close" @click="statementPop = false">
              <van-icon name="cross" />
            </div>
          </div>
          <div class="pop-bottom">
            <van-button
              size="small"
              @click="statementPop = false"
              class="cancel"
              type="default"
              >取消</van-button
            >
            <van-button size="small" @click="statementPopConfirm" type="info"
              >确认</van-button
            >
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import { Area, Popup, NumberKeyboard, Icon, Button, Toast, Dialog } from 'vant'

Vue.use(Icon)
Vue.use(Area)
Vue.use(Popup)
Vue.use(NumberKeyboard)
Vue.use(Button)
Vue.use(Toast)
Vue.use(Dialog)
import { idCardNoReg, bankCardNoReg } from '@/utils/utils.js'
import areaList from '@/utils/area_list.js'
import { goLogin } from '@/service/request.js'
import {
  validateUserStage,
  getTrainingSubsidyInfo,
  updateTrainingSubsidyInfo,
} from '@/service/common'
export default {
  components: {},
  data() {
    return {
      pageError: false,
      vanAreaShow: false,
      initCity: '',
      areaList,
      idKeyboard: false,
      show: false,
      bankCardNo: '',
      agreeCheck: false,
      statementPop: false,

      name: '',
      phone: '',
      dateDuring: '',
      formData: {
        candidateId: '',
        idCardNo: '',
        bankName: '',
        bankProvince: '',
        bankCardNo: '',
      },
    }
  },
  async created() {
    await this.init()
  },
  mounted() {
    this.frogReport('/event/subsidyCollect/pageView')
  },
  methods: {
    idCardNoRegValidator(val) {
      return idCardNoReg.test(val)
    },
    bankCardNoRegValidator(val) {
      // let valCopy = val && val.replace(/\s/g, '')
      // console.log('valCopy', valCopy, bankCardNoReg.test(valCopy))
      // return bankCardNoReg.test(valCopy)
      return bankCardNoReg.test(val)
    },
    async init() {
      try {
        const { srId } = this.$route.query
        const flag = await validateUserStage(srId)
        if (flag) {
          const res = await getTrainingSubsidyInfo(srId)
          if (!res) {
            this.pageError = true
            return
          }
          const {
            phone,
            name,
            dateDuring,
            bankCardNo,
            bankName,
            bankProvince,
            candidateId,
            idCardNo,
          } = res
          this.name = name
          this.phone = phone
          this.dateDuring = `${dateDuring.slice(0, 12)}${dateDuring.slice(-6)}`
          this.bankCardNo = bankCardNo
          this.formData.candidateId = candidateId
          this.formData.idCardNo = idCardNo
          this.formData.bankCardNo = bankCardNo
          this.formData.bankName = bankName
          this.formData.bankProvince = bankProvince
          try {
            if (this.formData.bankProvince) {
              for (let i in this.areaList.city_list) {
                if (
                  this.formData.bankProvince.includes(
                    this.areaList.city_list[i],
                  )
                ) {
                  this.initCity = i
                  return
                }
              }
            }
          } catch (error) {}
        } else {
          this.pageError = true
        }
      } catch (error) {
        console.log('error', error)
        this.pageError = true
      }
    },
    bankNameChange(val) {
      this.formData.bankName = val.replace(/\s/g, '')
    },
    format() {
      this.$nextTick(() => {
        this.bankCardNo = this.formData.bankCardNo
        // if (/\S{5}/.test(this.formData.bankCardNo)) {
        //   this.bankCardNo = this.bankCardNo
        //     .replace(/\s/g, '')
        //     .replace(/(.{4})/g, '$1 ')
        // }
      })
    },
    areaConfirm(val) {
      this.formData.bankProvince = `${val[0].name}${val[1].name}`
      this.vanAreaShow = false
    },
    statementPopConfirm() {
      this.statementPop = false
      this.agreeCheck = true
    },
    async submit() {
      Dialog.confirm({
        title: '确认',
        message: '确认提交吗？',
      })
        .then(() => {
          this.submitConfirm()
        })
        .catch(() => {})
    },
    async submitConfirm() {
      try {
        const { srId } = this.$route.query
        await updateTrainingSubsidyInfo(srId, this.formData)
        this.frogReport('/click/subsidyCollect/submite')
        Toast({
          message: '提交成功',
          forbidClick: true,
          onClose() {
            goLogin()
          },
        })
      } catch (error) {
        console.log(error)
      }
    },
    frogReport(url, extra = []) {
      this.$addFrog(1531, url, [
        { key: 'submitresumeid', value: this.$route.query.srId },
        ...extra,
      ])
    },
  },
}
</script>
<style lang="less" scoped>
.page-error-info {
  max-width: 750px;
  margin: 0 auto;
  p {
    margin: 0 auto;
  }
}
.subsidy-wrapper {
  max-width: 750px;
  margin: 0 auto;
  -webkit-font-smoothing: antialiased;
  word-wrap: break-word;
  background: #f0f2f5;
  height: 100vh;
  overflow-x: hidden;
  overflow-y: scroll;
  & .title {
    padding: 16px 8px 12px;
    font-size: 14px;
    color: rgba(92, 92, 92, 1);
    line-height: 20px;
    margin-bottom: 0;
  }
  .agree {
    display: flex;
    padding: 30px 12px 0;
    .select-c {
      width: 16px;
      height: 16px;
      border: 1px solid #1890ff;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      .select-o {
        display: flex;
        width: 10px;
        height: 10px;
        background-color: #1890ff;
        border-radius: 50%;
      }
    }
    .text-w {
      margin-left: 8px;
      font-size: 12px;
      line-height: 16px;
      display: flex;
      align-items: center;
      justify-content: center;
      .text-l {
        color: #9b9b9b;
      }
      .text-r {
        margin-left: 3px;
        color: #1890ff;
      }
    }
  }
}
</style>
<style lang="less">
.statement-pop {
  width: 85%;
  height: 70%;
  border-radius: 8px;
}
.statement-pop-w {
  height: 100%;
  position: relative;
  overflow: hidden;
  .pop-title-w {
    background-color: #fff;
    z-index: 777;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 53px;
    border-bottom: 1px solid #f0f2f5;
    .pop-title {
      font-size: 16px;
      color: #333333;
      padding: 0 16px;
    }
    .pop-close {
      align-items: center;
      height: 100%;
      display: flex;
      padding: 0 16px;
    }
  }
  .pop-content {
    height: calc(100% - 106px);
    margin-top: 53px;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 16px;
    .tit {
      font-size: 16px;
      line-height: 22px;
      color: #333;
      margin: 0 0 16px;
    }
    .item {
      font-size: 14px;
      line-height: 22px;
      color: #666;
      margin: 0 0 16px;
    }
  }
  .pop-bottom {
    position: absolute;
    background-color: #fff;
    padding: 0 16px;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 53px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    border-top: 1px solid #f0f2f5;
    .cancel {
      margin-right: 15px;
      border: none;
      color: #999;
    }
  }
}
.train-confirm-field {
  .van-field__label {
    width: 96px;
  }
  .van-field__control {
    -webkit-font-smoothing: antialiased;
  }
  &.van-cell {
    padding: 16px 12px;
  }
  &.id-card-no,
  &.bank-card-no {
    .van-field__value {
      display: flex;
      justify-content: space-between;
      .van-field__body {
        flex: 1;
        margin-right: 3px;
      }
    }
  }
  &.bank-name {
    .van-field__error-message {
      text-align: right;
    }
  }
  &.bank-province {
    .van-field__error-message {
      text-align: right;
    }
    .van-field__label {
      width: 116px;
    }
    .van-field__control {
      text-align: right;
    }
    .van-field__button {
      display: flex;
    }
  }

  &.disabled {
    .van-field__control {
      font-family: PingFang SC;
      color: #9b9b9b;
    }
  }
}
</style>
